export const MAX_PEERS = 10;
